export const lrem = (num: number) => {
  return `${num > 0 ? 'min' : 'max'}(calc(100vw / var(--base-width) * ${num}), calc(${num}px * var(--base-ratio)))`
}